import { reactive } from 'vue';

// Create a reactive store object
const paginationStore = reactive({ currentPage: 1 });

export default paginationStore;
